<template lang='pug'>
  section.dashboard.canned-responses-dashboard
    h1.page-title Coaching Canned Responses

    button.btn.add-canned-response(@click="setSelectedResponse({})")
      | Add canned response &nbsp; +
    br
    br
    canned-response-list(
      :source-list-data="cannedResponseSet"
      :trigger-search-input-focus="true"
      v-on:select-canned-response="setSelectedResponse"
      v-on:delete-canned-response="deleteCannedResponse")
    canned-response-form(
      :selected-response="selectedResponse"
      :selected-on="selectedOn"
      :selected-index.sync="selectedIndex"
      v-on:new-canned-response-added="init")
</template>

<script>
import CannedResponseList from '@/components/coaching/cannedResponses/CannedResponseList.vue';
import CannedResponseForm from '@/components/coaching/cannedResponses/CannedResponseForm.vue';
import alertSvc from '@/services/alertSvc.js';
import modalSvc from '@/services/modalSvc.js';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CoachingCannedResponseManager',
  components: {
    CannedResponseList,
    CannedResponseForm
  },
  data() {
    return {
      cannedResponseSet: [],
      editResponseMode: false,
      selectedResponse: null,
      selectedOn: null,
      selectedIndex: null,
      responseFormShown: false
    };
  },
  computed: {
    ...mapGetters(['cannedResponseMessages'])
  },
  methods: {
    init() {
      this.getCannedResponseMessages().then(() => {
        this.cannedResponseSet = this.cannedResponseMessages.slice();
      });
    },
    setSelectedResponse(response) {
      // Pass a single response to canned response form
      this.selectedResponse = response;
      // Indicate that we have modified source data
      this.selectedOn = Date.now();
    },
    deleteCannedResponse(response) {
      // Confirm that we want to delete this item
      const tab = '&nbsp;&nbsp;&nbsp;&nbsp;';

      modalSvc.confirm(
        {
          title: 'Delete canned message',
          message: `Are you sure you want to delete this message?
          <br/><br/>
          ${tab}<b>Title:</b> ${response.title}<br/>
          ${tab}<b>Author:</b> ${response.author}`,
          confirmButtonText: 'Delete message',
          cancelButtonText: 'Cancel',
          confirmButtonClass: 'error'
        },
        () => {
          // onConfirm callback
          this.deleteCannedResponseMessage(response.id).then(response => {
            if (response.data.succeeded) {
              modalSvc.hide();
              alertSvc.success('Coaching canned message deleted.');
              this.init();
            } else {
              modalSvc.hide();
              alertSvc.error(
                'Coaching canned message unable to be deleted. Please reload the page and try again.'
              );
            }
          });
        },
        () => {
          // onCancel callback
          modalSvc.hide();
        }
      );
    },
    ...mapActions([
      'getCannedResponseMessages',
      'deleteCannedResponseMessage'
    ])
  },
  mounted() {
    this.init();
  }
};
</script>


<style lang="scss" scoped>
.canned-responses-dashboard {
  position: relative;
  min-height: calc(100vh - 8.25em);
  overflow: hidden;
  padding: 0 5px;
}
</style>
